module.exports = __webpack_public_path__ + "static/studio-illustration-b4306e8f56e574803c36cce76bc940ed.svg";